<template>
  <b-row
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    class="content-header"
  >

    <!-- Content Left -->
    <b-col class="content-header-left mb-2" cols="12" md="12">
      <b-row class="align-items-center breadcrumbs-top">
        <b-col col lg="8">
          <h3 class="content-header-title pr-1 mb-0 d-flex align-items-center">
            <span v-if="isMobile" v-on:click="toggleCollapse()" class="material-icons-round mr-2 text-primary menu-icon">menu</span> 
            <span class="material-icons-outlined mr-50">{{$route.meta.icon}}</span> {{ $route.meta.pageTitle }}
          </h3>
          <div class="breadcrumb-wrapper">
            <b-breadcrumb class="pl-0">
              <b-breadcrumb-item to="/">
                <span class="material-icons-round mr-50 breadcrumb-home-icon">home</span>
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-for="item in $route.meta.breadcrumb"
                :key="item.text"
                :active="item.active"
                :to="item.to"
              >
                {{ item.text }}
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>
        <b-col cols="auto" lg="4" class="mt-lg-0">
          <div class="d-flex w-100 justify-content-end">
            <template v-if="!isPublic">
              <app-search v-if="!isMobile" class="w-100"></app-search>
              <button v-if="isMobile" v-on:click="showSearch = !showSearch" class="btn btn-xs btn-icon btn-secondary">
                <span class="material-icons-outlined">search</span>
              </button>
            </template>
          </div>
        </b-col>
      </b-row>
      <b-collapse v-if="isMobile && !isPublic" v-model="showSearch">
        <app-search class="w-100 mt-1"></app-search>
      </b-collapse>
    </b-col>
  </b-row>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem, BRow, BCol, BDropdown, BDropdownItem, BButton,BCollapse
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import useVerticalLayout from '@core/layouts/layout-vertical/useVerticalLayout'
import AppSearch from './AppSearch.vue'

export default {
  directives: {
    Ripple,
  },
  data(){
    return {
      showSearch:true
    }
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
    BCollapse,
    AppSearch
  },
  methods:{
    toggleCollapse() {
      useVerticalLayout().toggleVerticalMenuActive()
      useVerticalLayout().isVerticalMenuCollapsed.value = !useVerticalLayout().isVerticalMenuCollapsed.value
    },
  },
  watch:{
    isMobile(){
      this.showSearch = false
    }
  },
  computed:{
    isMobile(){
      return useVerticalLayout().isMobile.value
    },
    isVerticalMenuCollapsed(){
      return useVerticalLayout().isVerticalMenuCollapsed.value
    },
    isPublic(){
      return this.$route.meta?.public == true
    }
  }
}
</script>

<style scoped>
  .breadcrumb-home-icon{
    font-size: 20px;
  }
  .menu-icon{
    font-size: 30px;
    cursor: pointer;
    border-right: 1px solid #d6dce1;
    padding-right: 1rem;
  }
  .content-header-title{
    border-right: none !important;
  }
</style>